module.exports = __webpack_public_path__ + "static/media/cross.cb6ce89c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/AutoSuggestInput/cross.svg
// module id = 293
// module chunks = 0